import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
//import { SplashScreen } from '@capacitor/splash-screen';
import { MenuController } from '@ionic/angular';
import { ApirestService } from './apirest.service';
import { App } from '@capacitor/app';
import { Platform } from '@ionic/angular';

//console.time('AppLoadTime');

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  paymentHandler: any = null;
  public user = '';
  public username = '';
  public appPages = [];
  public labels = [];
  public img_profile = '';
  //public apiUrl: string = "http://localhost:8085/";
  public apiUrl = '';
  public logged: string | null = null;
  //public split_pane = true;
  public split_pane: any = '';

  constructor(
    private router: Router,
    private menuController: MenuController,
    public service: ApirestService,
    private platform: Platform,
  ) {
    //this.initializeApp();
  }

  async ngOnInit() {
    //this.showSplash();
    //this.user = '';
    //this.username = '';
    this.apiUrl = this.service.apiUrl;

    this.router.events.subscribe((event) => {
      if (
        event instanceof NavigationEnd &&
        event.urlAfterRedirects === '/home'
        //event.urlAfterRedirects.startsWith('/home')
      ) {
        if (!localStorage.getItem('token')) {
          this.router.navigate(['/login']);
          return;
        }
        var dataUser = localStorage.getItem('user');
        var email = localStorage.getItem('username');
        this.logged = localStorage.getItem('logged');
        const isDesktop = window.innerWidth > 1025;

        if (this.logged === 'true') {
          console.log('logged t', this.logged);
          document.body.classList.add('logged-in');
          //this.split_pane = true;
          if (isDesktop) {
            this.split_pane = true;
          } else {
            this.split_pane = '';
          }
        } else {
          console.log('logged f', this.logged);
          document.body.classList.remove('logged-in');
          this.split_pane = false;
        }

        console.log('datatat');
        console.log(dataUser);

        if (dataUser) {
          this.user = dataUser;
          this.username = email;
          this.getImg();
        }
      }
    });

    this.getAppPages2();
    this.checkAppLaunchUrl();
  }

  /* async initializeApp() {
    await this.platform.ready(); // Espera a que Ionic esté listo
    console.time('AppLoadTime');
    console.timeEnd('AppLoadTime'); // Fin de medición
  } */

  getAppPages2() {
    this.appPages = [
      /* { title: 'Inicio', url: '/home/', icon: 'home' }, */
      //{ title: `CUSTOMER'S DASHBOARD`, subtitle :'dashboard' },
      /* {
        title: 'PROFILE', url: '/sync/',
        children: [
          { title: `${this.user}`, url: '/sync/' },
          { title: `${this.username}`, url: '/sync/' },
        ]
      }, */
      { title: 'INBOX (0)', url: '/inbox/' },
      { title: 'SHEDULED TRIPS (0)' }, //url

      {
        title: 'MY PROFILE',
        url: '/myProfile/',
        /* children: [
          { title: 'My profile ', url: '/myProfile/' },
          { title: 'Change my password  ', url: '/changePassword/' },
          { title: 'My car', url: '/sync/', },
          { title: 'Add a car', url: '/sync/', },
        ] */
      },
      {
        title: 'CARD INFORMATION',
        url: '/cardInformation/',
      },
      {
        title: 'MY PAYMENT METHODS',
        url: '/myPayments/',
        /* children: [
           { title: 'Bank account  ', url: '/sync/' },
          { title: 'My venmo', url: '/sync/', },
          { title: 'My Cash App', url: '/sync/', },
          { title: 'My Paypal', url: '/sync/', }, 
        ], */
      },
      {
        title: 'WALLET',
        url: '/myPayments/',
        /* children: [
           { title: 'Bank account  ', url: '/sync/' },
          { title: 'My venmo', url: '/sync/', },
          { title: 'My Cash App', url: '/sync/', },
          { title: 'My Paypal', url: '/sync/', }, 
        ], */
      },
      {
        title: 'RUNNING ORDERS (0)',
        //url: "/sync/",
        children: [
          /* { title: 'Earnings ', url: '/sync/' },
           { title: 'Bank account  ', url: '/sync/' },
          { title: 'My venmo', url: '/sync/', },
          { title: 'My Cash App', url: '/sync/', },
          { title: 'My Paypal', url: '/sync/', }, */
        ],
      },
      {
        title: 'GPS',
        //url: "/home/", // Aquí 'google' es el parámetro que se pasa
        //"/home/waze"
        children: [
          { title: 'Google', url: '/home/google' },
          { title: 'Waze', url: '/home/google' },
        ],
      },

      //{ title: 'RATE YOUR SERVICE', url: '/sync/', },
      {
        title: 'HISTORY',
        //url: "/sync/",
        children: [
          //{ title: 'See all history requests ', url: '/servicesHistory/' },
          //{ title: 'Find by request number ', url: '/servicesHistory/' },
          { title: 'My trips', url: '/servicesHistory/' },
        ],
      },

      {
        title: 'FEES',
        //url: "/sync/",
        children: [
          //{ title: 'Courier fees', url: '/courierFees/' },
          //{ title: 'Calculation fees', url: '/calculationFees/' },
          { title: 'Fees & Calculations', url: '/earning-calculations/' },
        ],
      },
      { title: 'LOST & FOUND', url: '/lostFound/' },
      { title: 'SAFETY', url: '/safety/' },
      { title: 'CONTACT US', url: '/contactUs/' },
      { title: 'LOG OUT', url: '/login/' },
    ];
  }

  /* invokeStripe() {
    if (!window.document.getElementById('stripe-script')) {
      const script = window.document.createElement('script');
      script.id = 'stripe-script';
      script.type = 'text/javascript';
      script.src = 'https://checkout.stripe.com/checkout.js';
      script.onload = () => {
        this.paymentHandler = (<any>window).StripeCheckout.configure({
          //key: 'pk_test_51M3T5fKOplobDjkm3betuQ16yPq3bw0JA5LoKV6GaKdnAan6xE8bZ2db0CrdvdsAU8bFXw02SXZRiEWnOXRkjC9A00ylk3zZGT',
          key: 'pk_test_51MRp2OD2zVFXFkpBt4OBDZU7GSw5bod3CmslOZdN98S365Q80cRfz6Qubqqvlq9OMgXBJwCmMr7MUbfcWb2eun7j008XGfyzmC',
          locale: 'auto',
          token: function (stripeToken: any) {
            console.log(stripeToken);
            alert('Payment has been successfull!');
          },
        });
      };
      window.document.body.appendChild(script);
    }
  } */

  logoOut() {
    localStorage.setItem('token', '');
    localStorage.setItem('user', '');
    localStorage.setItem('username', '');
    localStorage.setItem('rol_user', '');
    localStorage.setItem('param', '');
    localStorage.setItem('logged', '');
    this.split_pane = false;
    setTimeout(() => {
      this.closeMenu();
    }, 500);
  }

  /* async showSplash(){
    await SplashScreen.show({
      autoHide: true,
      showDuration: 2000,
    });
  } */

  getImg() {
    console.log('img consult');
    const body = {
      username: this.username,
    };
    console.log('img body', body);

    this.service.queryPostRegular('drivers/imgProfile', body).subscribe(
      (response) => {
        let result = response;
        console.log('result de img', result);
        this.img_profile = result.img;
        console.log('img_profile', this.img_profile);
      },
      (err) => {
        console.log(err);
      },
    );
  }

  closeMenu() {
    this.menuController.isOpen().then((isOpen) => {
      if (isOpen) {
        this.menuController.close();
      }
    });
  }

  async checkAppLaunchUrl() {
    App.addListener('appStateChange', ({ isActive }) => {
      console.log('App state changed. Is active?', isActive);
    });

    App.addListener('appUrlOpen', ({ url }) => {
      if (url) {
        console.log('App opened with URL:', url);

        if (url.includes('home')) {
          console.log('redirect a home');
          /*  const service_id = url.split('/')[2];
          console.log('serviceId ',service_id); */
          this.router.navigate([`/home`]);
        }
      }
    });

    App.addListener('appRestoredResult', (data) => {
      console.log('Restored state:', data);
    });
  }
}
